<template>
    <div class="customers">
        <div :class="['wrap-boxes',{'wrap-opacity': boxActive != null}]">
          <template v-for="(stat, index) in customerStats">
          <div :class="['box st-' +stat.code,{'active': boxActive == stat.code}]" @click="filterCustomers(stat.code)" :key="index">
            <span>{{stat.total}}</span>
            <p>{{stat.name}}</p>
          </div>
          </template>
        </div>
        <div class="box-white-wrapper">
            <vs-table search :data="clients" pagination max-items="10">
                <template slot="header" v-if="userInfoData.role == Roles.Admin">
                    <vs-button color="primary" to="customer/manage/" type="border" icon="library_add">Agregar Cliente</vs-button>
                </template>
                <template slot="thead">
                    <vs-th sort-key="typename">Cuenta </vs-th>
                    <vs-th sort-key="fullName">Nombre </vs-th>
                    <vs-th sort-key="email">Email </vs-th>
                    <vs-th sort-key="mobile"> Tel&eacute;fono </vs-th>
                    <vs-th sort-key="statuscode"> Estado </vs-th>
                    <vs-th sort-key="id"></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].typename">
                        <span :class="`status status-${data[indextr].typecode}`">{{data[indextr].typename}}</span>
                    </vs-td>
                    <vs-td :data="data[indextr].fullName">
                        {{data[indextr].fullName}}
                    </vs-td>
                    <vs-td :data="data[indextr].email">
                        <a :href="`mailto:${data[indextr].email}`"> {{data[indextr].email}}</a>
                    </vs-td>
                    <vs-td :data="data[indextr].mobile">
                        {{data[indextr].mobile}}
                    </vs-td>
                    <vs-td :data="data[indextr].statuscode">
                        <div :class="['circle', data[indextr].statuscode === 1 ? 'success' : 'danger']"></div>
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                            <router-link :to="`/customers/${data[indextr].id}`"><feather type="eye"/></router-link>
                        </div>
                    </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>
<script>
import { Role } from '@/helpers/Role.js'
import { mapState } from 'vuex'
import ClientDataService from "@/services/ClientDataService";
// import { required, sameAs, minLength, email } from 'vuelidate/lib/validators'

export default {
    name: 'Customers',
    data() {
      return {
        clients: [],
        Roles:{},
        boxActive: null,
        customerStats: []
      }
    },
    beforeMount() {
        this.$Progress.start();
    },
    created(){
        this.Roles = Role
    },
    mounted () {
      this.retrieveCustomers()
      this.getCustomersStats()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    methods:{
        retrieveCustomers() {
            ClientDataService.getAll(this.boxActive)
            .then(response => {
                this.clients = response.data;
                console.log('Customers', response.data)
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo los clientes!',color:'danger',icon:'error_outline'})
            });
        },
        getCustomersStats() {
            console.log(222);
            ClientDataService.getCustomersStats()
            .then(response => {
                this.customerStats = response.data;
                this.$Progress.finish()
                console.log('STATS', response.data)
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo las estadisticas de los clientes!',color:'danger',icon:'error_outline'})
            });
        },
        filterCustomers(index){
            console.log(index);
            this.boxActive != index ? this.boxActive =  index : this.boxActive = null
            this.retrieveCustomers()
        }
    }
}
</script>
